<template>
<div>
  <div class="flex">
    <div class="mb-4 w-1/4">
      <vs-button color="primary" type="filled" @click="showCreate" v-if="$checkRole('accountant')"
                 icon="control_point" class="mt-4">
        {{ $t('message.salaryProject.newPayout') }}
      </vs-button>
    </div>
    <div class="mt-4 w-2/3 text-right leading-form">
      <vs-button @click="getByStatus(null)" line-origin="center"
                 color="primary" type="flat" class="mr-2">
        {{ $t('message.salaryProject.payAll') }}
      </vs-button>
      <vs-button @click="getByStatus(0)" line-origin="center"
                 color="primary" type="flat" class="mr-2">
        {{ $tc('message.salaryProject.actsStatus', 0) }}
      </vs-button>
      <vs-button @click="getByStatus(1)" line-origin="center"
                 color="primary" type="flat" class="mr-2">
        {{ $tc('message.salaryProject.actsStatus', 1) }}
      </vs-button>
      <vs-button @click="getByStatus(2)" line-origin="center"
                 color="primary" type="flat" class="mr-2">
        {{ $tc('message.salaryProject.actsStatus', 2) }}
      </vs-button>
    </div>
  </div>
  <vs-table
    stripe :data="payouts" pagination :maxItems="10"
    class="w-full mt-4" @selected="setSelected"
    :noDataText="$t('message.salaryProject.noDataText')">
    <template slot="thead">
      <vs-th>{{ $t('message.salaryProject.tableHeaderNumber') }}</vs-th>
      <vs-th>{{ $t('message.salaryProject.tableHeaderData') }}</vs-th>
      <vs-th v-if="false">{{ $t('message.salaryProject.tableHeaderBill') }}</vs-th>
      <vs-th>{{ $t('message.salaryProject.tableHeaderType') }}</vs-th>
      <vs-th v-if="false">{{ $t('message.salaryProject.tableHeaderPeriod') }}</vs-th>
      <vs-th>{{ $t('message.salaryProject.tableHeaderStatus') }}</vs-th>
      <vs-th>{{ $t('message.salaryProject.tableHeaderNote') }}</vs-th>
      <vs-th>{{ $t('message.salaryProject.tableHeaderActions') }}</vs-th>
    </template>
    <template :slot-scope="{payouts}">
      <template  v-for="row in payouts">
        <vs-tr :key="row.id">
          <vs-td>{{ row.id }}</vs-td>
          <vs-td>{{ row.date }}</vs-td>
          <vs-td v-if="false">{{ row.mainBill }}</vs-td>
          <vs-td>{{ $tc('message.salaryProject.actsType', row.type_payment) }}</vs-td>
          <vs-td>{{ $tc('message.salaryProject.actsStatus', row.status) }}</vs-td>
          <vs-td>{{ row.note }}</vs-td>
          <vs-td>
            <vs-button color="primary" class="inline-block mr-2" @click="editClick(row)"
                       v-if="row.status === 0" type="border" icon="edit" />
            <vs-button color="primary" class="inline-block mr-2" @click="editClick(row)"
                       v-else type="border" icon="info" />
            <vs-button color="primary" class="inline-block mr-2" type="border" icon="content_copy" v-if="false" />
            <vs-button color="primary" class="inline-block mr-2" type="border" icon="get_app" v-if="false" />
            <vs-button color="primary" class="inline-block" type="border" icon="print" v-if="false" />
          </vs-td>
        </vs-tr>
      </template>
    </template>
  </vs-table>
</div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'PayoutsTable',
  props: ['payouts', 'getUserRole'],
  methods: {
    showCreate () {
      this.$emit('show-create')
    },
    setSelected (event) {
      this.$emit('set-selected', event)
    },
    editClick (data) {
      this.$emit('open-edit', data)
    },
    getByStatus (status) {
      this.$emit('get-status', status)
    }
  },
  computed: {
    ...mapGetters('utils', ['getUserRole'])
  }
}
</script>

<style scoped>

</style>
